/**
 * PetsBuy header search bar.
 *
 * A real GET form (works without JS). With JS, clicking or typing in the bar
 * opens Horizon's predictive-search modal and forwards the typed text so the
 * shopper gets instant results with images.
 */
class SearchBar extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    if (!this.input) return;

    this.input.addEventListener('click', this.#open);
    this.input.addEventListener('input', this.#open);
    this.input.addEventListener('keydown', (event) => {
      // Enter submits natively to /search; everything else goes to the modal.
      if (event.key === 'Enter') return;
      if (event.key.length === 1) this.#open(event);
    });
  }

  #open = (event) => {
    const modal = document.getElementById('search-modal');
    if (!modal || typeof modal.showDialog !== 'function') return;

    event?.preventDefault?.();
    modal.showDialog();

    const modalInput = modal.querySelector('input.search-input');
    if (!modalInput) return;

    const value = this.input.value;
    requestAnimationFrame(() => {
      modalInput.focus();
      if (value && modalInput.value !== value) {
        modalInput.value = value;
        modalInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  };
}

if (!customElements.get('search-bar')) {
  customElements.define('search-bar', SearchBar);
}
